import { FormFooter } from '@r-and-a-shared-ui/common-forms-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { MEMBERSHIP_MODELS, SSO_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: ()=>FormFooter,
  mapEntryToProps: (entry: SSO_MODELS.FormFooter & MEMBERSHIP_MODELS.FormFooter) =>
    kontentAiDataMapping.form_footer(entry),
};
